import { render } from "./employeeEditProfile.vue?vue&type=template&id=4ab09644&ts=true"
import script from "./employeeEditProfile.vue?vue&type=script&lang=ts"
export * from "./employeeEditProfile.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__